import React, { FC, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useMutation } from '@apollo/client'
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts'
import { SOCIAL_LOGIN } from 'graphql/service'
import { useAuth } from 'customHooks/useAuth'

const debug = false

const AuthCallbackX: FC = () => {

  const { loginWithToken } = useAuth()
  const location = useLocation()
  const { showGlobalError, showGlobalMessage } = useGlobalAlerts()

  const [socialLogin] = useMutation(SOCIAL_LOGIN)

  // Dependency list updated during ESLint cleanup.
  // This provider's OAuth flow has not been runtime-tested.
  // Revalidate during the planned OAuth integration work.
  useEffect(() => {
    const params = new URLSearchParams(location.search)

    const code = params.get('code')
    const returnedState = params.get('state')
    const oauthError = params.get('error')

    if (debug) {
      console.log('X code:', code)
      console.log('X returnedState:', returnedState)
      console.log('X oauthError:', oauthError)
    }

    if (oauthError) {
      showGlobalError(oauthError)
      return
    }

    if (!code) {
      showGlobalError('Missing authorization code.')
      return
    }

    const savedState = sessionStorage.getItem('oauth_state')
    if (!returnedState || !savedState || returnedState !== savedState) {
      showGlobalError('Invalid OAuth state. Please try again.')
      return
    }

    const codeVerifier = sessionStorage.getItem('pkce_verifier_X')
    if (!codeVerifier) {
      showGlobalError('Missing PKCE code verifier. Please try again.')
      return
    }

    const redirectUri = `${window.location.origin}/auth/callback/x`

    socialLogin({
      variables: {
        input: {
          provider: 'X', // <-- если бэк ждёт TWITTER, поменяй на 'TWITTER'
          authorizationCode: code,
          codeVerifier,
          redirectUri,
        },
      },
    })
      .then((res) => {
        const token = res?.data?.socialLogin?.accessToken
        if (!token) {
          showGlobalError('Social login failed: no access token returned.')
          return
        }

        loginWithToken(token, '/account/dashboard')
        showGlobalMessage('Signed in successfully.')
      })
      .catch((e) => {
        showGlobalError(e?.message || 'Social login failed.')
      })
  }, [location.search, loginWithToken, showGlobalError, showGlobalMessage, socialLogin])

  return <div style={{ padding: 100 }}>Completing X sign-in...</div>
}

export default AuthCallbackX
